import { Injectable } from '@angular/core';
import { HubConnectionState } from '@microsoft/signalr';
import { BehaviorSubject } from 'rxjs';
import Info from '../models/info.model';

@Injectable({
  providedIn: 'root',
})
export class StatusBarService {
  public readonly state$ = new BehaviorSubject<HubConnectionState>(HubConnectionState.Disconnected);
  public readonly info$ = new BehaviorSubject<Info>({} as Info);

  public setState(state: HubConnectionState) {
    this.state$.next(state);
  }

  public setInfo(info: Info) {
    this.info$.next(info);
  }
}
